import { render } from "./ModificaDatiForm.vue?vue&type=template&id=1aed03e0"
import script from "./ModificaDatiForm.vue?vue&type=script&lang=js"
export * from "./ModificaDatiForm.vue?vue&type=script&lang=js"

import "./ModificaDatiForm.vue?vue&type=style&index=0&id=1aed03e0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__